import { RouteComponentProps } from 'react-router-dom';
import qs from 'query-string';
import { AppDispatch } from 'src/store';
import { IQueryParams } from 'src/types';
import { removeEmpty } from 'src/utils/removeEmpty';
import { createAction } from '@reduxjs/toolkit';

import { createFilterRequest, deleteFilterRequest, fetchFiltersListRequest, updateFilterRequest } from './requestHandlers';
import { IFilter, IFilterData } from './types';

export const loadFiltersStart = createAction('filters/load/start');
export const loadFiltersListSuccess = createAction<IFilterData>('filters/load/success');

const defaultParams = {
  page: '0',
  size: '10',
};

export const fetchFiltersList = (
  history: RouteComponentProps['history'],
  params: IQueryParams = {},
  isInitialLoading?: boolean,
  type?: string,
) => {
  return async (dispatch: AppDispatch): Promise<void> => {
    if (isInitialLoading) {
      dispatch(loadFiltersStart());
    }
    const initialParams = qs.parse(history.location.search);

    const mergedParams = type === 'reset' ? defaultParams : removeEmpty({ ...defaultParams, ...initialParams, ...params });
    const data = await fetchFiltersListRequest(mergedParams);
    if (data) {
      dispatch(loadFiltersListSuccess(data));
      history.replace({
        search: qs.stringify(mergedParams, { skipNull: true }),
      });
    }
  };
};

export const createFilter = async (data: Partial<IFilter>): Promise<Partial<IFilter>> => createFilterRequest(data);

export const updateFilter = async (data: Partial<IFilter>): Promise<Partial<IFilter>> => updateFilterRequest(data);

export const deleteFilter = async (id: string | number): Promise<void> => deleteFilterRequest(id);
